import { api } from './api';

export interface MeUser {
  id: string;
  email: string | null;
  name: string | null;
  pictureUrl: string | null;
  countryCode: string | null;
  primaryLocale: string | null;
  isAdmin: boolean;
  hasPassword: boolean;
  mfaEnabled?: boolean;
  linkedProviders: {
    google: boolean;
    microsoft: boolean;
    github: boolean;
    apple: boolean;
  };
}

export type DeletionReason =
  | 'found_alternative'
  | 'privacy_concerns'
  | 'bugs_errors'
  | 'missing_features'
  | 'too_complicated'
  | 'not_using'
  | 'other';

export const usersApi = {
  async me(): Promise<MeUser> {
    const r = await api.get<MeUser>('/api/users/me');
    return r.data;
  },

  async updateProfile(patch: { name?: string; countryCode?: string; primaryLocale?: string }): Promise<MeUser> {
    const r = await api.patch<MeUser>('/api/users/me', patch);
    return r.data;
  },

  async changePassword(body: { currentPassword: string; newPassword: string }): Promise<void> {
    await api.put('/api/users/me/password', body);
  },

  async uploadAvatar(file: File): Promise<MeUser> {
    const fd = new FormData();
    fd.append('file', file);
    const r = await api.post<MeUser>('/api/users/me/avatar', fd);
    return r.data;
  },

  async deleteAccount(body: { password: string; reason: DeletionReason; feedbackText?: string }): Promise<void> {
    await api.delete('/api/users/me', { data: body });
  },

  /** GDPR/APPI right-of-access: download the user's personal data as JSON. */
  async exportData(): Promise<void> {
    const r = await api.get('/api/users/me/export', { responseType: 'blob' });
    const url = URL.createObjectURL(r.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'cadencez-data-export.json';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
